import { useCallback } from 'react';
import { useFormTemplateContext } from '../EditFormTemplatePage/FormTemplateContext';
import { useFormTemplateUpdate } from '../EditFormTemplatePage/hooks/useFormTemplateUpdate';
import { EditableFormTemplate } from '../FormTemplateEditor/types';

/**
 * changes to calendars save "on the fly" as those get submitted, but save the whole form template if
 * unsaved changes exist from the other tabs
 */
export function useSubmitOnCalendarsTab({
  formTemplate,
  organizationId,
}: {
  formTemplate: EditableFormTemplate;
  organizationId: string;
}) {
  const { resetDirtyState } = useFormTemplateContext();
  const [saveFormTemplate, { isLoading: isSubmitting }] = useFormTemplateUpdate(
    { resetDirtyState },
  );

  const onSubmit = useCallback(async () => {
    await saveFormTemplate({ formTemplate, organizationId });
  }, [saveFormTemplate, formTemplate, organizationId]);

  return { onSubmit, isSubmitting };
}
